module.exports = __webpack_public_path__ + "img/ic_eye_on.39dabc2f.svg";